module.exports = [
  { code: 'AB', name: 'Alberta' },
  { code: 'BC', name: 'Columbie-Britannique' },
  { code: 'MB', name: 'Manitoba' },
  { code: 'NB', name: 'Nouveau-Brunswick' },
  { code: 'NL', name: 'Terre-Neuve' },
  { code: 'NT', name: 'Territoire du N.-O.' },
  { code: 'NS', name: 'Nouvelle-Écosse' },
  { code: 'NU', name: 'Nunavut' },
  { code: 'ON', name: 'Ontario' },
  { code: 'PE', name: 'Î.-P.-É.' },
  { code: 'QC', name: 'Québec' },
  { code: 'SK', name: 'Saskatchewan' },
  { code: 'YT', name: 'Yukon' },
];
